<template>
  <div>
    <slot></slot>
    <div :id="name" class="uk-modal-container" data-uk-modal>
      <div class="uk-modal-dialog">
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <div class="uk-modal-header" v-if="title">
          <div class="uk-modal-title">{{ title }}</div>
          <span v-if="subtitle">{{ subtitle }}</span>
        </div>
        <div class="uk-modal-body">
          <div class="uk-margin">
            <app-form :id="formId" :extra-data="extraData"></app-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppForm from './Form.vue'
export default {
  props: {
    name: { required: true, type: String },
    title: { required: false, type: String },
    subtitle: { required: false, type: String },
    formId: { required: true },
    extraData: { required: false, default: null },
  },
  components: { AppForm }
}
</script>
